<template>
  <v-container fluid grid-list-lg mb-3>
    <v-layout row wrap>
      <v-flex xs12 sm6 offset-sm3>
        <h2 class="heading-2 align-left">Personal Information</h2>
        <v-alert :value="true" v-if="error != null" type="error">{{
          error.message
        }}</v-alert>
        <v-alert
          :value="true"
          v-if="ticketMessage != null"
          type="info"
          color="blue-grey"
          >{{ ticketMessage }}</v-alert
        >
        <v-alert :value="true" v-if="success != null" type="success">{{
          success.message
        }}</v-alert>

        <v-layout justify-center column>
          <template v-if="ready">
            <v-form ref="form" v-model="valid" @submit="updateUser">
              <p class="dob">
                Name
                <span class="dobChange"
                  >(Please email ticketsales@avfc.co.uk to update your
                  name)</span
                >
              </p>
              <v-layout row>
                <v-flex xs12>
                  <v-text-field
                    outline
                    v-model="firstName"
                    :rules="firstNameRules"
                    readonly
                    label="First Name *"
                    required
                  ></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <v-text-field
                    outline
                    v-model="lastName"
                    :rules="lastNameRules"
                    readonly
                    label="Last Name *"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex xs12>
                  <v-text-field
                    outline
                    v-model="username"
                    :rules="usernameRules"
                    readonly
                    label="Email *"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex xs12>
                  <v-text-field
                    outline
                    v-model="phoneNumber"
                    :rules="phoneRules"
                    label="Mobile Phone Number"
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <p class="dob">
                Date of Birth
                <span class="dobChange"
                  >(Please email ticketsales@avfc.co.uk to update your date of
                  birth)</span
                >
              </p>
              <v-layout row>
                <v-flex xs12 sm4>
                  <v-select
                    :items="days"
                    label="DD"
                    v-model="dobDay"
                    :rules="dobRules"
                    :readonly="isReadonly"
                    outline
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-select
                    :items="months"
                    label="MM"
                    v-model="dobMonth"
                    :rules="dobRules"
                    outline
                    :readonly="isReadonly"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-select
                    :items="years"
                    label="YYYY"
                    v-model="dobYear"
                    :rules="dobRules"
                    outline
                    :readonly="isReadonly"
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12>
                  <v-select
                    :items="genderOptions"
                    label="Gender"
                    v-model="gender"
                    outline
                  ></v-select>
                </v-flex>
              </v-layout>

              <v-layout row>
                <h3 class="heading-3 align-left address-align">Address</h3>
              </v-layout>
              <v-layout row>
                <p class="address-align">
                  In order to provide online ticketing purchasing functionality
                  we require your primary billing address.
                </p>
              </v-layout>
              <v-layout row>
                <v-flex xs12 pb-0>
                  <v-text-field
                    outline
                    v-model="address1"
                    :rules="addressRules"
                    label="Address line 1*"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12 pb-0>
                  <v-text-field
                    outline
                    v-model="address2"
                    label="Address line 2"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12 pb-0>
                  <v-text-field
                    outline
                    v-model="address3"
                    label="Address line 3"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12 pb-0>
                  <v-text-field
                    outline
                    v-model="locality"
                    label="City / Town"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12 pb-0>
                  <v-text-field
                    outline
                    v-model="region"
                    label="County / Region"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12 pb-0>
                  <v-text-field
                    outline
                    v-model="postal_code"
                    :rules="addressRules"
                    label="Postal Code*"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12 pb-0>
                  <v-select
                    outline
                    :items="countries"
                    v-model="country"
                    item-text="name"
                    label="Country*"
                  ></v-select>
                </v-flex>
              </v-layout>

              <v-layout row align-center mx-1>
                <v-spacer />
                <button
                  type="submit"
                  class="button"
                  :disabled="!valid || !ready"
                  color="success"
                >
                  {{ saveButtonText }}
                </button>
              </v-layout>
            </v-form>
          </template>

          <template v-else>
            <div class="text-xs-center">
              <v-progress-circular
                :size="50"
                color="accent"
                indeterminate
              ></v-progress-circular>
            </div>
          </template>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  name: "UserProfile",
  data() {
    return {
      ready: false,
      valid: true,
      firstNameRules: [(v) => !!v || "First name is required"],
      lastNameRules: [(v) => !!v || "Last name is required"],
      usernameRules: [
        (v) => !!v || "Email address is required",
        (v) => /.+@.+/.test(v) || "Email must be valid",
      ],
      dobRules: [
        (v) => !!v || "Date of Birth is required",
        (v) =>
          (
            this.dobYear +
            "-" +
            ("0" + this.dobMonth).slice(-2) +
            "-" +
            ("0" + this.dobYear).slice(-2)
          ).toString() < new Date().toISOString().split("T")[0] ||
          "Date can't be in the future",
      ],
      addressRules: [(v) => !!v || "You must fill in this address field"],
      ssoid: "",
      firstName: "",
      lastName: "",
      phoneNumber: "",
      username: "",
      gender: "",
      dobDay: null,
      dobMonth: null,
      dobYear: null,
      originalEmail: "",
      error: null,
      ticketMessage: null,
      success: null,
      loading: false,
      address: null,
      address1: "",
      address2: "",
      address3: "",
      locality: "",
      region: "",
      postal_code: "",
      country: "",
      countries: [],
      genderOptions: ["", "Female", "Male", "Prefer not to say", "Other"],
      days: [],
      months: [],
      years: [],
      saveButtonText: "Save Details",
      age: null,
      isReadonly: true
    };
  },
  created() {
    // load this user's latest information
    this.$getCurrentUserAttributes().subscribe(
      (userData) => {
        this.ssoid = userData["sub"];
        this.username = userData.email;
        this.firstName = userData.given_name;
        this.lastName = userData.family_name;
        this.phoneNumber = userData.phone_number;
        this.phoneNumber = userData.phone_number;
        this.originalEmail = userData.email;
        this.gender = userData.gender;

        if (userData.birthdate) {
          var birthdayDates = userData.birthdate.split("-");
          this.dobDay = parseInt(birthdayDates[2]);
          this.dobMonth = parseInt(birthdayDates[1]);
          this.dobYear = parseInt(birthdayDates[0]);
          this.isReadonly = true
          this.checkAge();
        } else {
          // If a DoB was never set (maybe they were created via the CMS) we allow it to be written
          this.isReadonly = false
        }

        if (userData["address"]) {
          this.address = JSON.parse(userData["address"]);
          if (this.address) {
            //set our address fields
            if (this.address["street_address"]) {
              var addressFields = this.address["street_address"].split("\n");
              this.address1 = addressFields[0];
              this.address2 = addressFields[1];
              this.address3 = addressFields[2];
            }
            this.locality = this.address.locality;
            this.region = this.address.region;
            this.postal_code = this.address.postal_code;
            this.country = this.address.country;
          }
        }
        fetch("/countries.json")
          .then((r) => r.json())
          .then(
            (json) => {
              this.countries = json.countries;
            },
            (response) => {
              // eslint-disable-next-line
              console.error("Error loading json:", response);
            }
          );

        // tell the app that we've finished loading
        this.ready = true;
      },
      (err) => {
        // eslint-disable-next-line
        console.error(
          "Unable to load user profile, session may not be present."
        );
      }
    );
  },
  watch: {
    dobDay: function (val, oldVal) {
      if (typeof this.$refs.form !== "undefined") {
        this.$refs.form.validate();
      }
    },
    dobMonth: function (val, oldVal) {
      if (typeof this.$refs.form !== "undefined") {
        this.$refs.form.validate();
      }
    },
    dobYear: function (val, oldVal) {
      if (typeof this.$refs.form !== "undefined") {
        this.$refs.form.validate();
      }
    },
  },
  /*watch: {
    pass: function (val, oldVal) {
      this.$refs.form.validate()
    },
    passConfirm: function (val, oldVal) {
      this.$refs.form.validate()
    }
  },*/
  computed: {
    phoneRules() {
      //alert(this.phoneNumber)
      if (!this.phoneNumber) {
        return [];
      } else {
        return [
          (v) =>
            /^$|^\+(?:[0-9] ?){6,14}[0-9]$/.test(v) ||
            "Phone number must be valid and contain international dail code e.g. +447891234567",
        ];
      }
    },
  },
  mounted() {
    this.populateDates();

    // if(typeof localStorage.returnUrl != 'undefined'){
    // if(localStorage.returnUrl.includes('ticket')){
    //   this.ticketMessage = 'Please update your details to ensure they are up to date. Upon clicking \'Confirm Details\' you will be returned to the ticketing platform'
    //   this.saveButtonText = 'Confirm Details'
    // }
    var redirectLocation = localStorage.returnUrl.substring(8).split(".")[0];

    if (redirectLocation === "tickets") {
      this.ticketMessage =
        "Please update your details to ensure they are up to date. Upon clicking 'Confirm Details' you will be returned to the ticketing platform";
      this.saveButtonText = "Confirm Details";
    } else if (redirectLocation === "memberships") {
      this.ticketMessage =
        "Please update your details to ensure they are up to date. Upon clicking 'Confirm Details' you will be returned to the memberships platform";
      this.saveButtonText = "Confirm Details";
    } else if (redirectLocation === "auction") {
      this.ticketMessage =
        "Please update your details to ensure they are up to date. Upon clicking 'Confirm Details' you will be returned to the auction platform";
      this.saveButtonText = "Confirm Details";
    } else {
      this.ticketMessage =
        "Please update your details to ensure they are up to date. Upon clicking 'Confirm Details' you will be returned to the referring platform";
      this.saveButtonText = "Confirm Details";
    }
    // }
  },
  methods: {
    pad(num, size) {
      var s = num + "";
      while (s.length < size) s = "0" + s;
      return s;
    },
    checkAge() {
      this.age = null;
      this.age = this.calculateAge(this.dobYear, this.dobMonth, this.dobDay);
    },
    populateDates() {
      for (var d = 1; d < 32; d++) {
        this.days.push(d);
      }
      for (var m = 1; m < 13; m++) {
        this.months.push(m);
      }
      var thisYear = new Date().getFullYear();
      for (var y = thisYear + 1; y > 1900; y--) {
        this.years.push(y);
      }
    },
    redirectUser(e) {
      if (localStorage.returnUrl) {
        var redirectLocation = localStorage.returnUrl
          .substring(8)
          .split(".")[0];
        var redirectAlert = "";
        // if they were from a trusted referrer and we need to send them back with a JWT
        if (redirectLocation === "shop") {
          redirectAlert = "You are being redirected to the Online Store";
        } else if (redirectLocation === "tickets") {
          redirectAlert = "You are being redirected to the Ticketing website";
        } else if (redirectLocation === "video") {
          redirectAlert = "You are being redirected to Villa TV";
        } else if (redirectLocation === "rewards") {
          redirectAlert = "You are being redirected to the Rewards website";
        } else if (redirectLocation === "avfc") {
          redirectAlert =
            "You are being redirected to the Official Club website";
        } else {
          redirectAlert = "You are being redirected to the referring platform";
        }
        alert(redirectAlert);
        var authUser = this.$getAuthenticatedUser();
        authUser.getSession(function (err, session) {
          var jwtToken = session.getIdToken().getJwtToken();
          if (localStorage.responseType == "post") {
            var form = document.createElement("form");
            document.body.appendChild(form);
            form.method = "post";
            form.action = localStorage.returnUrl;
            var input = document.createElement("input");
            input.type = "hidden";
            input.name = "token";
            input.value = jwtToken;
            form.appendChild(input);
            localStorage.removeItem("returnUrl");
            localStorage.removeItem("suppressToken");
            localStorage.removeItem("responseType");
            form.submit();
          } else {
            var firstQueryChar = "?";
            if (localStorage.returnUrl.includes("?")) {
              // account for ? in string
              firstQueryChar = "&";
            }
            var redirect = localStorage.returnUrl;
            if (!localStorage.suppressToken) {
              redirect = redirect + firstQueryChar + "token=" + jwtToken;
            }
            localStorage.removeItem("returnUrl");
            localStorage.removeItem("suppressToken");
            localStorage.removeItem("responseType");
            window.location = redirect;
          }
        });
      }
    },
    crmXCMPush(username) {
      var crmXCMPushURL =
        process.env.VUE_APP_XCM_CRM_API + "/user/push/" + username;
      return axios({
        method: "get",
        url: crmXCMPushURL,
      });
    },
    crmPush(username) {
      var vm = this;
      Promise.all([vm.crmXCMPush(username)]).then(function (results) {
        vm.error = null;
        var response = {
          message: "Your details have been updated successfully.",
        };
        vm.success = response;
        vm.ready = true;

        vm.$getSession().subscribe((sessionData) => {
          // Post Data to SeatGeek's server (using the id Token)
          setTimeout(function () {
            var lastSub = vm.$cookie.get(
              `CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.LastAuthUser`
            );
            var idToken = vm.$cookie.get(
              `CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${lastSub}.idToken`
            );
            axios
              .post(`${process.env.VUE_APP_SEATGEEK_SRO_ENDPOINT}`, idToken)
              .then(function (seatGeekResponse) {
                // Tell our parent window that the profile has been updated (if one exists)
                if (window.opener) {
                  window.opener.postMessage("profileUpdated", "*");
                }
                vm.redirectUser();
              })
              .catch(function (error) {
                // Tell our parent window that the profile has been updated (if one exists)
                if (window.opener) {
                  window.opener.postMessage("profileUpdated", "*");
                }
                vm.redirectUser();
              });
          }, 500);
        });
      });
    },
    updateUser(e) {
      e.preventDefault();
      this.ready = false;

      var email = this.username;
      var firstName = this.firstName;
      var lastName = this.lastName;
      var phoneNumber = this.phoneNumber;
      var gender = this.gender;

      var attributesList = {
        given_name: firstName,
        family_name: lastName,
        phone_number: phoneNumber,
        gender: gender,
      };

      var street_address =
        this.address1 + "\n" + this.address2 + "\n" + this.address3;

      var address = {
        street_address: street_address,
        locality: this.locality,
        region: this.region,
        postal_code: this.postal_code,
        country: this.country,
      };
      attributesList["address"] = JSON.stringify(address);

      if (this.isReadonly===false && this.dobDay && this.dobMonth && this.dobYear) {
        attributesList["birthdate"] =
          this.dobYear +
          "-" +
          this.pad(this.dobMonth, 2) +
          "-" +
          this.pad(this.dobDay, 2);
      }

      if (this.originalEmail.toLowerCase() != email.toLowerCase()) {
        attributesList["email"] = email;
        // trigger verification workflow
      }
      var vm = this;
      this.$updateAttributes(attributesList).subscribe(
        (response) => {
          vm.crmPush(this.ssoid);
        },
        (err) => {
          //if we get an UnkownError it is more than likely because the user has a status of 'FORCE_CHANGE_PASSWORD' in AWS Cognito
          this.success = null;
          this.error = err;
          this.ready = true;
        }
      );
    },
  },
};
</script>

<style scoped>
.address-align {
  margin-left: 20px;
}

.dob {
  /* margin: 0 0 1.25em; */
  color: #878787;
  font-size: 15px;
  line-height: 22px;
}
.dobChange {
  font-size: 11px;
}
</style>